import { Avatar, Box, Typography } from "@mui/material";
import { Link, useRecordContext, useTranslate } from "react-admin";

import { formatName } from "../../lib/formatName";
import { ProcedureRecord } from "../../types/procedure";

export const ProcedureAllPatientsField = () => {
  const record = useRecordContext<ProcedureRecord>();
  const translate = useTranslate();

  if (!record) return null;

  // Get all participating patients
  const allPatients = record.procedureParticipants.nodes
    .map(participant => participant.patient)
    .filter((patient): patient is NonNullable<typeof patient> => patient !== null && patient !== undefined);

  if (allPatients.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {translate("Procedure.fields.noPatients")}
      </Typography>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {allPatients.map(patient => {
        const patientName = formatName(patient.user);
        return (
          <Link key={patient.id} to={`/Patient/${patient.id}/show`}>
            <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer", "&:hover": { opacity: 0.8 } }}>
              <Avatar src={patient.user?.avatarUrl ?? undefined} alt={patientName} sx={{ width: 32, height: 32 }} />
              <Typography variant="body2" color="primary">
                {patientName}
              </Typography>
            </Box>
          </Link>
        );
      })}
    </Box>
  );
};
